import React from 'react';
import { observer } from 'mobx-react';

import { useProfileWidgetStore } from './StoreProvider';

export const SwitchContainer = observer((props: Partial<Record<UserType, React.ComponentType>>) => {
  const { userType } = useProfileWidgetStore();
  const componentType = getComponentType(userType);
  const View = props[componentType];

  if (!View) return null;

  return <View />;
});

const getComponentType = (userType?: string): UserType => {
  switch (userType) {
    case 'contractor':
      return 'Contractor';
    case 'employee':
      return 'Employee';
    case 'partner':
      return 'Partner';
    default:
      return 'Customer';
  }
};

type UserType = 'Customer' | 'Contractor' | 'Employee' | 'Partner';
